export default "__VITE_ASSET__DRethy2q__"